/**
 * Finds a parameter by name in an array and returns its value
 * @param {Array<{name: string, value: *}>} parameters - Array of parameter objects with name and value
 * @param {string} parameterName - Name of the parameter to find
 * @returns {*} Value of the found parameter, or undefined if not found
 * @example
 * const parameters = [
 *     { name: 'startTime', value: '09:00' },
 *     { name: 'endTime', value: '17:00' }
 * ];
 * getParameterValueByName(parameters, 'startTime') // returns '09:00'
 * getParameterValueByName(parameters, 'unknown') // returns undefined
 * getParameterValueByName(null, 'startTime') // returns undefined
 */
export function getParameterValueByName(parameters, parameterName) {
    return parameters?.find((param) => param.name === parameterName)?.value;
}
